/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reviews': {
    width: 28,
    height: 20,
    viewBox: '0 0 28 20',
    data: '<path pid="0" d="M20 10c1.84 0 3.32-1.493 3.32-3.333S21.84 3.334 20 3.334A3.335 3.335 0 0020 10zM10 8.667a3.983 3.983 0 003.987-4c0-2.213-1.773-4-3.987-4-2.213 0-4 1.787-4 4s1.787 4 4 4zm10 4c-2.44 0-7.333 1.227-7.333 3.667v3h14.667v-3c0-2.44-4.894-3.667-7.334-3.667zm-10-1.333C6.894 11.334.667 12.894.667 16v3.334H10v-3c0-1.134.44-3.12 3.16-4.627-1.16-.24-2.28-.373-3.16-.373z" _fill="#098AFF"/>'
  }
})
